"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const AppBar_1 = require("@material-ui/core/AppBar");
const Button_1 = require("@material-ui/core/Button");
const Card_1 = require("@material-ui/core/Card");
const Dialog_1 = require("@material-ui/core/Dialog");
const DialogActions_1 = require("@material-ui/core/DialogActions");
const DialogContent_1 = require("@material-ui/core/DialogContent");
const Grid_1 = require("@material-ui/core/Grid");
const Hidden_1 = require("@material-ui/core/Hidden");
const IconButton_1 = require("@material-ui/core/IconButton");
const MenuItem_1 = require("@material-ui/core/MenuItem");
const Tab_1 = require("@material-ui/core/Tab");
const Tabs_1 = require("@material-ui/core/Tabs");
const TextField_1 = require("@material-ui/core/TextField");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const Close_1 = require("@material-ui/icons/Close");
const FilterList_1 = require("@material-ui/icons/FilterList");
const FilterUtils = require("@pbl/pbl-react-core/lib/models/filters/filsters-utils");
const TimeUtil_1 = require("@pbl/pbl-react-core/lib/utils/TimeUtil");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const yup = require("yup");
const config_1 = require("../config/config");
const FieldRenderer_1 = require("../field/FieldRenderer");
const FilterSectionStyle_1 = require("./jss/FilterSectionStyle");
const SelectedFiltersSection_1 = require("./SelectedFiltersSection");
class FilterSection extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            openDialog: false,
            filters: Object.values(_.cloneDeep(this.props.filters))
                .sort((f1, f2) => f1.order - f2.order)
                .reduce((obj, f) => (Object.assign(Object.assign({}, obj), { [f.key]: f })), {}),
            currentTab: this.props.tabHeader ? this.props.tabHeader.startIndex || 0 : 0,
            errorMessage: '',
            customDateRangeStart: undefined,
            customDateRangeEnd: undefined,
            prevCustomDateRangeStart: undefined,
            prevCustomDateRangeEnd: undefined,
            prevFilters: undefined
        };
        this.renderHeader = (hasSelected) => {
            const { classes, title, filterTitle } = this.props;
            return ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.filterContainer }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h6", gutterBottom: true, color: "textPrimary", component: 'h2' }, { children: `${hasSelected ? 'Filtered Results' : title}` })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.filterButtonSection }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", gutterBottom: true, color: "textPrimary", className: classes.filterText, component: 'span' }, { children: `${filterTitle}:` })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": filterTitle, className: (0, classnames_1.default)({
                                        [classes.filterButtonColors]: !this.props.darkMode,
                                        [classes.filterButtonColorsDark]: this.props.darkMode
                                    }, classes.filterButton, 'containedButton'), onClick: this.toggleDialog }, { children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small" }) }))] }))] })) })));
        };
        this.renderTabbedHeader = () => {
            const { classes, tabHeader, filterTitle } = this.props;
            const tabs = _.map((tabHeader || {}).tabs, tab => ((0, jsx_runtime_1.jsx)(Tab_1.default, { label: tab }, tab)));
            const options = _.map((tabHeader || {}).tabs, (tab, index) => ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ value: index }, { children: tab }), `${tab}_menu_item`)));
            return ((0, jsx_runtime_1.jsxs)(AppBar_1.default, Object.assign({ position: "static", className: classes.tabBar }, { children: [(0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ smUp: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, justifyContent: "space-between", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({ select: true, fullWidth: true, variant: "outlined", className: classes.tabBarSelect, value: this.state.currentTab, onChange: this.onTabSelectChange, InputProps: {
                                            className: classes.tabBarSelectInput
                                        } }, { children: options })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": filterTitle, className: (0, classnames_1.default)({
                                            [classes.tabFilterButton]: true,
                                            [classes.filterFab]: true
                                        }), onClick: this.toggleDialog }, { children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small" }) })) }))] })) })), (0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ xsDown: true }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, justifyContent: "space-between", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Tabs_1.default, Object.assign({ value: this.state.currentTab, onChange: this.onTabChange }, { children: tabs })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": filterTitle, className: (0, classnames_1.default)({
                                            [classes.tabFilterButton]: true,
                                            [classes.filterFab]: true
                                        }), onClick: this.toggleDialog }, { children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small" }) })) }))] })) }))] })));
        };
        this.renderOnlyFilter = () => {
            const { classes, filterTitle } = this.props;
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.filterButtonSection }, { children: [(0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ smDown: true }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: this.props.darkMode ? 'subtitle2' : 'subtitle1', gutterBottom: true, component: 'span', className: (0, classnames_1.default)({
                                [classes.filterText]: true
                            }), color: this.props.darkMode ? 'textSecondary' : 'textPrimary', style: { lineHeight: '20px' } }, { children: `${filterTitle}:` })) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": filterTitle, className: (0, classnames_1.default)({
                            [classes.filterButtonColors]: !this.props.darkMode,
                            [classes.filterButtonColorsDark]: this.props.darkMode
                        }, classes.tabButton, classes.filterButton, 'containedButton'), onClick: e => {
                            var _a, _b;
                            this.toggleDialog();
                            (_b = (_a = this.props).onIconClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                        } }, { children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small" }) }))] })));
        };
        this.renderFilters = (item, filterTitle) => {
            const { classes, theme, t } = this.props;
            const disableSelection = _.filter(item.filters, f => f.customDateFilterType === 'custom').length > 0
                ? _.filter(item.filters, f => f.customDateFilterType === 'custom')[0].isSelected
                : false;
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.filterCategoryContainer }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body2", color: "textPrimary", className: (0, classnames_1.default)({
                                [classes.textDark87]: this.props.darkMode
                            }) }, { children: t(item.header) })) })), (0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ elevation: 0, className: classes.categoryDetails, style: {
                            backgroundColor: disableSelection
                                ? theme.palette.grey[400]
                                : theme.palette.background.paper
                        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.categoryDetailsInner, role: "radiogroup" }, { children: _.filter(item.filters, f => f.customDateFilterType !== 'custom').map(filter => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "contained", className: (0, classnames_1.default)({
                                        [classes.filterItemBg]: !this.props.darkMode,
                                        [classes.filterItemBgDark]: this.props.darkMode,
                                        [classes.filterItem]: true,
                                        [classes.filterItemSelected]: filter.isSelected && !this.props.darkMode,
                                        [classes.filterItemSelectedDark]: filter.isSelected && this.props.darkMode,
                                        [classes.largeFilterItem]: true
                                    }, 'filterButton'), size: "small", disabled: disableSelection, role: "radio", "aria-label": `${filterTitle.replace('Filter ', '')} ${t(filter.name)}`, "aria-checked": filter.isSelected ? true : false, onClick: this.onFilterChange.bind(this, item.key, filter.name) }, { children: t(filter.name) }), filter.name))) })), _.filter(item.filters, f => f.customDateFilterType === 'custom').length > 0
                                ? this.renderCustomDateFilters(item)
                                : null] })), _.filter(item.filters, f => f.customDateFilterType === 'custom').length > 0
                        ? this.renderCustomDateFiltersButton(item)
                        : null] }), item.key));
        };
        this.renderCustomDateFiltersButton = (item) => {
            const { classes, t, theme } = this.props;
            const filterItem = _.filter(item.filters, f => f.customDateFilterType === 'custom')[0];
            if (filterItem.isSelected) {
                return null;
            }
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.customDateFiltersButton }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body2", color: "textPrimary", className: (0, classnames_1.default)({
                            [classes.textDark87]: this.props.darkMode
                        }), align: 'center' }, { children: `Need more precise search? Try,` })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ component: 'a', className: (0, classnames_1.default)({
                            [classes.textSecondary]: this.props.darkMode,
                            [classes.uppercase]: this.props.darkMode
                        }, classes.filterBtn, 'linkButton'), onClick: this.onFilterChange.bind(this, item.key, filterItem.name), color: this.props.darkMode
                            ? theme.palette.secondary.main
                            : config_1.config.internalConfig.BUTTON_BACKGROUND, variant: "text" }, { children: t(filterItem.name).toLocaleUpperCase() }))] })));
        };
        this.renderSelectedFilters = () => {
            const { filters, entityName } = this.props;
            return ((0, jsx_runtime_1.jsx)(SelectedFiltersSection_1.default, { filters: filters, entityName: entityName, onRemoveSelected: this.props.onRemoveSelected }));
        };
        this.renderCustomDateFilters = (item) => {
            const { classes, theme, t } = this.props;
            const filterItem = _.filter(item.filters, f => f.customDateFilterType === 'custom')[0];
            if (filterItem.isSelected) {
                const dateStart = this.getDateStart(filterItem, this.state.customDateRangeStart);
                const dateEnd = this.getDateEnd(filterItem, this.state.customDateRangeEnd);
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
                        backgroundColor: theme.palette.background.paper
                    } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.dialogHeader }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body2", color: "textPrimary", className: (0, classnames_1.default)({
                                        [classes.textDark87]: this.props.darkMode
                                    }) }, { children: t(filterItem.name) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": "Close", onClick: this.handleClearSelected.bind(this, true), className: 'iconButton' }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "small" }) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.dateRange }, { children: [(0, jsx_runtime_1.jsx)(FieldRenderer_1.default, { className: (0, classnames_1.default)(classes.dateField, classes.spaceRight), field: dateStart, onChange: this.onDateFilterChange.bind(this, item.key, filterItem.name, 'start') }, dateStart.key), (0, jsx_runtime_1.jsx)(FieldRenderer_1.default, { className: classes.dateField, field: dateEnd, onChange: this.onDateFilterChange.bind(this, item.key, filterItem.name, 'end') }, dateEnd.key)] })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "caption", color: "error", align: 'center' }, { children: this.state.errorMessage }))] })));
            }
            return null;
        };
        this.toggleDialog = () => {
            const { prevCustomDateRangeStart, prevCustomDateRangeEnd } = this.state;
            this.setState({
                openDialog: !this.state.openDialog,
                errorMessage: '',
                filters: this.props.filters,
                customDateRangeStart: prevCustomDateRangeStart,
                customDateRangeEnd: prevCustomDateRangeEnd
            });
        };
        this.handleSubmit = () => {
            const { filters: sections, customDateRangeStart, customDateRangeEnd, prevFilters } = this.state;
            const filters = {};
            _.each(_.keys(sections), key => {
                const section = sections[key];
                const sectionFilters = _.map(section.filters, filter => {
                    let isSelected = filter.isSelected;
                    if (filter.customDateFilterType === 'custom' &&
                        !customDateRangeStart &&
                        !customDateRangeEnd) {
                        filter.customDateRangeStart = null;
                        filter.customDateRangeEnd = null;
                    }
                    if (filter.customDateFilterType === 'custom' &&
                        (filter.customDateRangeStart === null || filter.customDateRangeEnd === null)) {
                        isSelected = false;
                    }
                    return Object.assign(Object.assign({}, filter), { isSelected });
                });
                filters[key] = Object.assign(Object.assign({}, section), { filters: sectionFilters });
            });
            let isValidationViolated = false;
            if (!!filters.DateFilterIndex && !!filters.DateFilterIndex.filters) {
                isValidationViolated = this.checkFilterValidation(filters);
            }
            if (!isValidationViolated) {
                this.props.onOk(filters);
                this.setState({ prevFilters: filters });
                this.setState({
                    prevCustomDateRangeStart: customDateRangeStart,
                    prevCustomDateRangeEnd: customDateRangeEnd
                });
                this.toggleDialog();
            }
        };
        this.handleClearSelected = (customDate) => {
            const { filters: sections } = this.state;
            const filters = {};
            Object.keys(sections).forEach(key => {
                const section = sections[key];
                const sectionFilters = _.map(section.filters, f => {
                    const filter = Object.assign(Object.assign({}, f), { isSelected: customDate ? f.isSelected : false });
                    if (filter.customDateFilterType === 'custom') {
                        filter.customDateRangeStart = null;
                        filter.customDateRangeEnd = null;
                        filter.isSelected = false;
                        this.setState({ customDateRangeStart: undefined, customDateRangeEnd: undefined });
                    }
                    return filter;
                });
                filters[key] = Object.assign(Object.assign({}, section), { filters: sectionFilters });
            });
            this.setState({ filters });
            this.setState({ errorMessage: '' });
        };
        this.onFilterChange = (sectionKey, filterKey) => {
            const { filters: sections } = this.state;
            const section = _.cloneDeep(sections[sectionKey]);
            const filters = !!section && !!section.filters
                ? section.filters.map(f => {
                    if (f.name === filterKey) {
                        f.isSelected = !f.isSelected;
                    }
                    else if (section.selectionType === 'single_select') {
                        f.isSelected = false;
                    }
                    const filterData = Object.assign({}, f);
                    return filterData;
                })
                : [];
            this.setState({
                filters: Object.assign(Object.assign({}, sections), { [sectionKey]: Object.assign(Object.assign({}, section), { filters }) })
            });
        };
        this.onDateFilterChange = (sectionKey, filterKey, filterDateType, value) => {
            const { filters: sections } = this.state;
            const section = _.cloneDeep(sections[sectionKey]);
            const filters = !!section && !!section.filters
                ? section.filters.map(f => {
                    if (f.name === filterKey) {
                        if (filterDateType === 'start') {
                            f.customDateRangeStart = value;
                            this.setState({ customDateRangeStart: value, prevCustomDateRangeStart: value });
                        }
                        else {
                            f.customDateRangeEnd = value;
                            this.setState({ customDateRangeEnd: value, prevCustomDateRangeEnd: value });
                        }
                    }
                    const filterData = Object.assign({}, f);
                    return filterData;
                })
                : [];
            this.setState({
                filters: Object.assign(Object.assign({}, sections), { [sectionKey]: Object.assign(Object.assign({}, section), { filters }) })
            });
        };
        this.onTabChange = (event, tabIndex) => {
            this.setState({ currentTab: tabIndex }, () => {
                if (this.props.tabHeader) {
                    this.props.tabHeader.onTabChange(tabIndex);
                }
            });
        };
        this.onTabSelectChange = (event) => {
            const tabIndex = event.target.value;
            this.setState({ currentTab: tabIndex }, () => {
                if (this.props.tabHeader) {
                    this.props.tabHeader.onTabChange(tabIndex);
                }
            });
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.filters !== prevProps.filters) {
            const filters = _.cloneDeep(this.props.filters);
            this.setState({ filters });
        }
    }
    render() {
        const { classes, filterTitle, tabHeader, onlyFilter = false, showClose = true, theme, t } = this.props;
        const { openDialog, filters } = this.state;
        const hasSelected = FilterUtils.hasSelected(filters);
        let header;
        if (tabHeader && tabHeader.tabs.length > 0) {
            header = this.renderTabbedHeader();
        }
        else if (onlyFilter) {
            header = this.renderOnlyFilter();
        }
        else {
            header = this.renderHeader(hasSelected);
        }
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [header, hasSelected && !onlyFilter && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: this.renderSelectedFilters() }))), (0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ fullWidth: true, maxWidth: "md", open: openDialog, className: (0, classnames_1.default)(classes.dialogBackdropDark, 'po-widget-dialog'), PaperProps: {
                        className: this.props.darkMode ? classes.dialogDark : classes.dialog
                    }, "aria-labelledby": "Filter-Model" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.modalStyles }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.dialogHeader }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ id: "Filter-Model", className: (0, classnames_1.default)({ [classes.textDark60]: this.props.darkMode }), variant: "h6", color: "textPrimary" }, { children: filterTitle || 'Filters' })), showClose && ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": "Close", onClick: this.toggleDialog, className: (0, classnames_1.default)('iconButton', classes.closeButton) }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "small" }) })))] })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: Object.keys(filters).map(key => this.renderFilters(filters[key], filterTitle)) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, Object.assign({ className: classes.filtersActions }, { children: [hasSelected && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.handleClearSelected.bind(this, false), color: config_1.config.internalConfig.BUTTON_BACKGROUND, variant: "text", className: (0, classnames_1.default)({
                                            [classes.textSecondary]: this.props.darkMode,
                                            [classes.uppercase]: this.props.darkMode
                                        }, classes.filterBtn, 'textButton') }, { children: t('history.filter.clearBtn') }))), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: this.handleSubmit, color: this.props.darkMode
                                            ? theme.palette.secondary.main
                                            : config_1.config.internalConfig.BUTTON_BACKGROUND, variant: "contained", className: (0, classnames_1.default)({
                                            [classes.buttonDark]: this.props.darkMode
                                        }, classes.filterBtn, 'containedButton') }, { children: "Done" }))] }))] })) }))] }));
    }
    getDateEnd(filterItem, value) {
        const dateEnd = {
            type: 'date',
            key: `${filterItem.name.replace(/\s+/g, '_')}_date_end`,
            label: 'End Date',
            get placeholder() {
                return this.label;
            },
            isRequired: true,
            validationSchema: yup.string().required(),
            minValue: !!filterItem.customDateRangeStart
                ? filterItem.customDateRangeStart.toDate()
                : (0, TimeUtil_1.nowUtc)().subtract(config_1.config.internalConfig.HISTORY_FILTER_START_DAYS, 'days').toDate(),
            maxValue: (0, TimeUtil_1.nowUtc)().toDate(),
            disabled: !filterItem.customDateRangeStart,
            value: !!filterItem.customDateRangeEnd ? filterItem.customDateRangeEnd : null,
            get fieldValue() {
                return !!filterItem.customDateRangeEnd ? value : undefined;
            }
        };
        return dateEnd;
    }
    getDateStart(filterItem, value) {
        const dateStart = {
            type: 'date',
            key: `${filterItem.name.replace(/\s+/g, '_')}_date_start`,
            label: 'Start Date',
            get placeholder() {
                return this.label;
            },
            isRequired: true,
            validationSchema: yup.string().required(),
            minValue: (0, TimeUtil_1.nowUtc)().subtract(config_1.config.internalConfig.HISTORY_FILTER_START_DAYS, 'days').toDate(),
            maxValue: !!filterItem.customDateRangeEnd
                ? filterItem.customDateRangeEnd.toString()
                : (0, TimeUtil_1.nowUtc)().toString(),
            value: !!filterItem.customDateRangeStart ? filterItem.customDateRangeStart.toDate() : null,
            get fieldValue() {
                return !!filterItem.customDateRangeStart ? value : undefined;
            }
        };
        return dateStart;
    }
    checkFilterValidation(filters) {
        const { customDateRangeStart, customDateRangeEnd } = this.state;
        let isValidationViolated = false;
        const customFilter = _.find(filters.DateFilterIndex.filters, {
            customDateFilterType: 'custom'
        });
        if (!!customFilter &&
            (!!customFilter.customDateRangeStart || !!customFilter.customDateRangeEnd)) {
            isValidationViolated = !customDateRangeStart || !customDateRangeEnd;
            if (isValidationViolated) {
                const missingField = !customDateRangeStart ? 'Start Date' : 'End Date';
                const errorMessage = `Please enter required field - ${missingField}`;
                this.setState({ errorMessage });
            }
        }
        return isValidationViolated;
    }
}
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(FilterSectionStyle_1.default)((0, react_i18next_1.withTranslation)()(FilterSection)));
//# sourceMappingURL=FilterSection.js.map